import { type HttpClient } from '@/application/interfaces/http-client';
import { Services } from '@/infra/services';
import { type ItemId } from '@/infra/services/catalog/model';

interface GetProductInfoProps {
  itemId: ItemId;
}

export async function getProductInfo(
  props: Readonly<GetProductInfoProps>,
  options?: HttpClient.BaseOptions
) {
  const { itemId } = props;

  return await Services.Catalog.Product.getProductInfo({ itemId }, options);
}
